/*
 *
 * NewTreatmentResultStep reducer
 *
 */

import {fromJS} from "immutable";
import {DEFAULT_ACTION, PLAN_ACTIVITY, PLAN_ACTIVITY_FAILED, PLAN_ACTIVITY_SUCCESS,} from "./constants";

export const initialState = fromJS({
  loading: true,
  data: null,
  planActivityResult: null,
  planActivityResultError: false,
});

function newTreatmentResultStepReducer(state = initialState, action) {
  switch (action.type) {
    case DEFAULT_ACTION:
      return state;
    /**
     * Plan activity
     */
    case PLAN_ACTIVITY:
      return state.set("loading", true)
        .set("planActivityResultError", false)
        .set("planActivityResult", null);
    case PLAN_ACTIVITY_SUCCESS:
      return state
        .set("loading", false)
        .set("data", action.result)
        .set("planActivityResult", action.result.plannedTreatment)
        .set("planActivityResultError", false);
    case PLAN_ACTIVITY_FAILED:
      return state
        .set("loading", false)
        .set("planActivityResult", null)
        .set("planActivityResultError", true);
    default:
      return state;
  }
}

export default newTreatmentResultStepReducer;
